<template>
  <div class="mb-4">
    <router-link :to="{ name:'round', params: { id: roundId } }">
      <underlined-heading color="red">{{ roundId }}</underlined-heading>
    </router-link>
    <tickets-table-editable
      :tickets="tickets"
      :validator="validator"
      @update:tickets="$emit('update', roundId, $event)"
    />
    <div class="text-right my-6 text-xl">
      <span class="text-grey block md:inline">Цена за тур:</span>
      {{ tickets.length }}
      <v-icon type="times"/>
      {{ priceForRound(roundId) | money }} = {{ getPriceForAddedTicketsInRound(roundId) | money }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UnderlinedHeading from '@/components/core/UnderlinedHeading'

/**
 * @module CartSingleRound
 */
export default {
  name: 'CartSingleRound',
  components: { UnderlinedHeading },
  props: {
    validator: {
      type: Object,
      default: null
    },
    tickets: {
      type: Array,
      default: () => []
    },
    roundId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('shop', ['getPriceForAddedTicketsInRound']),
    ...mapGetters('rounds', ['priceForRound'])
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
